/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import URI from 'urijs';
import state from '@bingads-webui-component-legacy/state/index';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { showLabelsPopup, filterOnLabelClick, navigateToManagePage } from '@bingads-webui-campaign/labels';
import { validateOrder, updateGridQuery, appendScopeParameter, getTargetEntity, handleShowRejectionReasonEnter, handleShowRejectionReasonLeave } from '@bingads-webui-campaign/summary-grid-helper';
import { showQualityScoreDetail, BudgetSplitView } from '@bingads-webui-campaign/campaignui-common-columns';
import { getEditorialReasonsTemplate } from '@bingads-webui-campaign/rsa-ad-customizer-attribute-column';
import { getRequestPermission } from '@bingads-webui-campaign/linkedin-delivery-status-column';
import { GridCustomizedPopupEditor, getEditorPositionAsideAnchor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { pgridFactory } from '@bingads-webui-campaign/pgrid-factory';
import { PageReady } from '@bingads-webui/page-ready';
import { insertPopoverContainer } from '@bingads-webui-campaign/fluctuation-common';
import { TopPanelCashbackSettings } from '@bingads-webui-campaign/top-panel-cashback-settings';
import { handleSortChange } from '@bingads-webui-campaign-legacy/bingadsgrid/service/state-manager-helper';
import { CampaignDeliveryStatusPopupFactory } from '@bingads-webui-campaign-legacy/campaigns-tab-campaigns/grid/delivery-status/delivery-status-popup-factory';
import { bulkEditChange } from '@bingads-webui-campaign-legacy/bulk-edit/service/bulk-edit';
import appConfig from '@bingads-webui-component-legacy/config/index';
import CopyPaste from '@bingads-webui-static-legacy/bulk-edit/view/copyPaste';
import Hotkeys from '@bingads-webui-component-legacy/hotkeys/index';
import jsdataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import pageContext from '@bingads-webui-static-legacy/page-context';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { notificationApi } from '@bingads-webui-react/notification-center';
import * as SharedBudgetModel from '@bingads-webui-campaign-legacy/shared-budget/model/shared-budget';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import ReactDOM from 'react-dom';
import React from 'react';
import { mergeStyleSets, DirectionalHint, Callout, Text } from '@fluentui/react';
import * as AppealAggregator from '@bingads-webui-campaign-legacy/editorial-appeal/aggregator';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import { DisclaimerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';
import BingAdsWebUIComponentLegacyRouterIndex from '@bingads-webui-component-legacy/legacy-router/index';
import { keyVault } from '@bingads-webui-react/popup-manager';
import { PerformanceInsightsToolTipCard } from '@bingads-webui-campaign-react/performance-insights';
import { openCampaignBidLandscape } from '../bid-landscape/index';
import { renderFluctuationInsightsTooltip, mccPerfFluxPopupContainerId, hideFluctuationInsightsTooltip, dismissFlucCallout } from './tooltips/fluctuation-tooltip';
import { hideBudgetCenterHelpTooltip, renderBudgetCenterHelpTooltip } from './tooltips/budget-center-help-tooltip';
import { renderConversionDeliveryStatusTooltip } from './tooltips/conversion-status-popup';
import { filterEnterKeyDown } from '../filter-entity-util';
import { getReasonTemplates } from './show-rejection-reasons';

const { legacyRouter } = BingAdsWebUIComponentLegacyRouterIndex;

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');
const commonI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/ads-tab/common');
const legacyGlobalI18n = window.globalLegacyI18n.get('$/i18n!legacy/global');
const locationTargeti18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/location-targets');

const permissions = appConfig.get('Permissions');
const {
  IsExperimentsOpenBetaEnabled,
  IsCampaignAdGroupCopyPasteEnabled,
  IsSmartShoppingCampaignEnabled,
  IsAccountLabelsEnabled,
  IsDeferredHoveringPopupEnabled,
} = permissions;
const budgetLimit = ['CampaignBudgetPaused', 'BudgetSuggestions'];
const autobiddingLimitedStatus = ['AutoBiddingLimitedInventoryLimit', 'AutoBiddingLimitedMaxCPCRestriction', 'AutoBiddingLimitedBudgetRestriction', 'AutoBiddingLimitedUnAttainableTarget', 'AutoBiddingPortfolioBidStrategyTrainingStatus'];
const linkedInPermissionRequired = ['LinkedInCompanyPagePaidMediaRequired'];
const customTemplateDeliveryStatus = [...budgetLimit, ...autobiddingLimitedStatus, ...linkedInPermissionRequired];
const disclaimerEditorialStatus = ['DisclaimerInfoRejected', 'DisclaimerInfoApprovedLimited', 'DisclaimerInfoRejectedAppealRejected', 'DisclaimerInfoApprovedLimitedAppealRejected'];
const popupContentKey = _.uniqueId(`${keyVault.hoveringPopup}-`);

export class CampaignsGrid extends DeterministicWrapperView {
  // performance targets details page also use campaign grid
  // verify functionalility to avoid regression after modification
  viewFactory({
    router,
    scope,
    filterService,
    preferenceConfig,
    gridConfig,
    serverContext,
    instrumentation,
    isForVNext = false,
    getPlugins,
    getGridConfig,
    enableCopyPaste = true,
    pageName,
    preexecuteFlag = false,
    theme,
    azureUrlRewrite,
    perfMarker,
    preferenceService,
    newI18n,
  }) {
    this.gridRemoved = false;
    this.filterService = filterService;
    this.router = router;
    this.scope = scope;
    this.isForVNext = isForVNext;
    this.enableCopyPaste = enableCopyPaste;
    this.serverContext = serverContext;
    this.instrumentation = instrumentation;
    this.pageName = pageName;
    this.preexecuteFlag = preexecuteFlag;
    this.theme = theme;
    this.azureUrlRewrite = azureUrlRewrite;
    this.perfMarker = perfMarker;
    this.preferenceService = preferenceService;
    this.newI18n = newI18n;

    const internalConfig = getGridConfig(this);

    let config = merge(internalConfig, gridConfig);
    this.gridName = config.name;

    // check if the order by column is supported as sortable
    validateOrder(preferenceConfig, config.columns, this.gridName, permissions);

    config = merge(config, preferenceConfig);

    this.grid = pgridFactory({
      gridConfig: config,
      plugins: getPlugins(this),
      preferenceConfig,
    });

    this.disclaimerRepos = new SharedRepository({
      schema: DisclaimerAdExtension,
      afterChangeComitted: _.noop,
    });
    this.appealAggregator = null;

    this.rejectionPopupContainerSelector = '#rejectionContainer';
    this.popoverId = 'delivery-status-popup-callout';

    this.conversionActivity = this.instrumentation && this.instrumentation.createScenarioAndActivity({
      scenarioName: 'conversionDeliveryStatusPopup',
      activityName: 'showConversionDeliveryStatusWarning',
    });

    if (isForVNext) {
      this.filterService.on('filter-state-changed', () => {
        if (!this.gridRemoved) {
          const filter = this.filterService.getCombinedFilter();
          updateGridQuery(
            this.grid.gridView,
            filter,
            true
          );
        }
      });
    }

    if (!this.preexecuteFlag && IsCampaignAdGroupCopyPasteEnabled && this.enableCopyPaste) {
      const bulkEditGridOptions = {
        filterService: this.filterService,
        gridView: this.grid.gridView,
        pgridPlugins: this.grid,
        isForVNext: this.isForVNext,
      };

      Hotkeys.on('copy', CopyPaste.copy.bind(CopyPaste, 'campaign', bulkEditGridOptions));
      if (this.isForVNext) {
        Hotkeys.on('paste', this.grid.paste.onClick);
      } else {
        Hotkeys.on('paste', CopyPaste.paste.bind(CopyPaste, bulkEditGridOptions));
      }
      Hotkeys.setup();
    }

    this.grid.gridView.on('willUpdate', (changes) => {
      // only after rendering, we do the patch
      const { _isRendered } = this.grid.gridView;
      if (_isRendered) {
        handleSortChange(changes, this.grid.gridView, config.name);
      }
    });

    this.grid.gridView.once('didReload', () => {
      this.grid.gridView.once('didRedraw', () => {
        PageReady.pageIsReady(this.pageName);
      }, this);
    });

    this.grid.pagination.on('change:page-number', (pageNumber) => {
      this.setPageNumberToState(pageNumber);
    });

    const eventDispatcher = _.extend({}, Backbone.Events);

    this.listenTo(eventDispatcher, 'wunderbar.collapsed', this.onWunderbarChange);
    this.listenTo(eventDispatcher, 'wunderbar.expanded', this.onWunderbarChange);
    this.deliveryStatusPopupFactory = new CampaignDeliveryStatusPopupFactory({
      grid: this.grid,
      perfMarker,
      scope,
      instrumentation,
    });
    this.on('inlineEditCashbackSetting', this.inlineEditCashbackSetting, this);
    return this.grid.gridView;
  }

  renderTrunk() {
    if (this.isForVNext) {
      this.filterService.initializeCombinedFilterPromise.then(() => {
        if (!this.gridRemoved) {
          const filter = this.filterService.getCombinedFilter();
          updateGridQuery(
            this.grid.gridView,
            filter,
            true
          );
        }
      });
    }
    super.renderTrunk();
  }

  inlineEditCashbackSetting(item) {
    const {
      Percent,
      MonthlyBudget,
      Scope,
      CouponsEnabled,
      PersonalizedOffersEnabled,
    } = item.CampaignCashback || {};

    const inlineEdit = new TopPanelCashbackSettings({
      CashbackPercent: Percent,
      CashbackMonthlyBudget: MonthlyBudget,
      CashbackScope: Scope,
      CouponsEnabled,
      PersonalizedOffersEnabled,
      deps: {
        i18n,
        decimal,
        pageContext,
        jsdataCampaign,
      },
      view: this,
      item,
      campaignName: item.Name,
    }).render();
    this.showTopPanelCashbackSettingEditor(inlineEdit);
  }

  showTopPanelCashbackSettingEditor(view) {
    // use defer here to wait for the dropdown menu to hide first
    _.defer(() => {
      if (this.editorView) {
        this.editorView.remove();
      }
      this.editorView = view;

      this.grid.gridView.overrideWith(this.editorView);

      this.editorView.once('cancel close', (response) => {
        this.grid.gridView.overrideWith(null);
        this.editorView.remove();
        this.editorView = null;

        if (response) {
          this.grid.gridView.refresh(true);
        }
      });
      window.scrollTo(0, 0);
    });
  }

  get events() {
    const events = {
      'click .quality-score-detail': 'showQualityScoreDetails',
      'click .labels-cell-container #see-all': 'onLabelsRowClicked',
      'click .labels-cell-item': (event) => {
        const targetEntity = getTargetEntity(event, this.grid.gridView);
        filterOnLabelClick(
          event,
          targetEntity.Labels,
          this.grid.gridView,
          this.filterService,
          IsAccountLabelsEnabled
        );
      },
      'click .manage-labels-button': () => navigateToManagePage(this.router),
      'click .budget-landscape-row': 'showBudgetLandscape',
      'click .delivery_status_with_inline_opportunities': 'showInlineOpportunityPanel',
      'click .experiment-budget-ellipsis': 'showExperimentBudgetPopup',
      'click .grid-column-Budget .bidlandscape_icon.enabled': 'showBidLandscape',
      'mouseover .grid-column-Budget .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, this, this.showLandscapeDisabledHelpInfo) : 'showLandscapeDisabledHelpInfo',
      'mouseout .grid-column-Budget .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonLeave, this, this.hideRejectionReason) : 'hideRejectionReason',
      'click .grid-column-biddingStrategyTargetCpa .bidlandscape_icon.enabled': 'showBidLandscape',
      'mouseover .grid-column-biddingStrategyTargetCpa .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, this, this.showLandscapeDisabledHelpInfo) : 'showLandscapeDisabledHelpInfo',
      'mouseout .grid-column-biddingStrategyTargetCpa .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonLeave, this, this.hideRejectionReason) : 'hideRejectionReason',
      'click .grid-column-biddingStrategyTargetRoas .bidlandscape_icon.enabled': 'showBidLandscape',
      'mouseover .grid-column-biddingStrategyTargetRoas .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, this, this.showLandscapeDisabledHelpInfo) : 'showLandscapeDisabledHelpInfo',
      'mouseout .grid-column-biddingStrategyTargetRoas .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonLeave, this, this.hideRejectionReason) : 'hideRejectionReason',
      'click .grid-column-Delivery .bidlandscape_icon.enabled': 'showBidLandscape', // TODO: Only show this if value = limited by auto-bidding-target
      'mouseover .grid-column-Delivery .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, this, this.showLandscapeDisabledHelpInfo) : 'showLandscapeDisabledHelpInfo',
      'mouseout .grid-column-Delivery .bidlandscape_icon.disabled': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonLeave, this, this.hideRejectionReason) : 'hideRejectionReason',
      'click .performance-metrics-fluctuation .clickable': 'showFluctuationInsightsPopup',
      'mouseenter .performance-metrics-fluctuation .clickable': 'showFluctuationInsightsTooltip',
      'mouseleave .performance-metrics-fluctuation .clickable': event => hideFluctuationInsightsTooltip({ event, view: this.grid.gridView }),
      'mouseenter .optimization_score_with_popover': 'showOptimizationScorePopover',
      'mouseleave .grid-column-OptimizationScoreColumn': 'hideOptimizationScorePopover',
      'mouseover .budgetCenterEntry': 'showBudgetCenterHelpInfo',
      'mouseleave .budgetCenterEntry': event => hideBudgetCenterHelpTooltip({ event, view: this.grid.gridView }),
      'keydown .budgetCenterEntry': filterEnterKeyDown(e => this.showBudgetCenterHelpInfo(e)),
      'mouseover .conversion-warning-delivery-status': IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, this, this.showConversionDeliveryStatusWarning) : 'showConversionDeliveryStatusWarning',
      'keydown .conversion-warning-delivery-status': filterEnterKeyDown(e => this.showConversionDeliveryStatusWarning(e)),
    };

    if (this.isForVNext) {
      events['mouseenter .delivery_status_with_reject_reasons'] = IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, this, this.showRejectionReason) : 'showRejectionReason';
      events['mouseleave .delivery_status_with_reject_reasons'] = IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonLeave, null, _.noop) : null;
      events['mouseleave .grid-column-Delivery'] = 'hideRejectionReason';
      events['click .delivery_status_with_reject_reasons'] = 'showRejectionReason';
      events['click .grid-column-Budget .bidlandscape_icon.disabled'] = 'showLandscapeDisabledHelpInfo';
      events['mouseover .budget-landscape-row'] = 'showRejectionReason';
      events['click .editorial_delivery_status_with_inline_appeals'] = 'showEditorialRejectionReason';
      events['mouseenter .editorial_delivery_status_with_inline_appeals'] = 'showEditorialRejectionReason';
      events['mouseenter .performance-insights-status'] = _.debounce(this.showPerformanceInsightsPopup, 100);
      events['mouseleave .performance-insights-status'] = 'hidePerformanceInsightsPopup';
    } else {
      events['click .delivery_status_with_reject_reasons'] = 'showRejectionReason';
      events['mouseover .budget-landscape-row'] = 'showBudgetLandscapeHelpInfo';
    }
    return events;
  }

  remove() {
    if (this.grid) {
      if (this.grid.toolbar && this.grid.toolbar.gridToolbarGroup) {
        this.grid.toolbar.gridToolbarGroup.remove();
        this.grid.toolbar = null;
      }
    }

    if (!this.preexecuteFlag && IsCampaignAdGroupCopyPasteEnabled && this.enableCopyPaste) {
      Hotkeys.reset();
    }

    dismissFlucCallout();

    this.gridRemoved = true;
    this.setPageNumberToState(0);
    super.remove();
  }

  setPageNumberToState(number) {
    state.set('pgridPageNumber', _.defaults({
      [this.gridName]: number,
    }, state.get('pgridPageNumber') || {}));
  }

  showOptimizationScorePopover(event) {
    const containerDOM = document.querySelector(this.rejectionPopupContainerSelector);
    const styles = mergeStyleSets({
      callout: {
        width: 320,
        padding: '20px 24px',
        fontSize: '12px',
      },
      title: { marginBottom: 12 },
      body: {},
    });
    ReactDOM.render(
      (
        <Callout className={styles.callout} target={event.target} directionalHint={DirectionalHint.rightCenter} role="alert">
          <Text className={styles.title} block variant="xLarge">
            {i18n.getString('Optimization_Score_Column_Warning_Title')}
          </Text>
          <Text className={styles.body} variant="small">
            {i18n.getString('Optimization_Score_Column_Warning_Text')}
          </Text>
        </Callout>
      ),
      containerDOM
    );

    this.optimizationScorePopoverShown = true;
  }

  showConversionDeliveryStatusWarning(event) {
    const item = getTargetEntity(event, this.grid.gridView);
    const { activity } = this.conversionActivity || {};

    if (activity) {
      activity.trace(`[ConversionDeliveryStatusPopup] Rendered - ${JSON.stringify({ campaignId: item.Id, goalDeliveryStatus: JSON.stringify(item.GoalStatusDetails) })}`);
    }


    renderConversionDeliveryStatusTooltip({
      i18n: this.newI18n,
      event,
      item,
      view: this.grid.gridView,
      activity,
      isConnectWithExpertEnabled: permissions.dynamic.AdsCopilotConversionTrackingLiveAgent,
    });

    this.conversionDeliveryStatusPopoverShown = true;
  }

  hideConversionDeliveryStatusWarning() {

  }

  hideOptimizationScorePopover() {
    if (this.optimizationScorePopoverShown) {
      ReactDOM.unmountComponentAtNode(document.querySelector(this.rejectionPopupContainerSelector));
      this.optimizationScorePopoverShown = false;
    }
  }

  showExperimentBudgetPopup(event) {
    const item = getTargetEntity(event, this.grid.gridView);
    const budgetSplitView = new BudgetSplitView({ item, i18n }).render();

    return new GridCustomizedPopupEditor({
      editorView: budgetSplitView,
      editorPositionFactory: getEditorPositionAsideAnchor($(event.target)),
      renderBelow: false,
      className: 'grid-popupeditor experiment-budget-popup',
    }).render();
  }

  showBidLandscape(event) {
    let bidLandscapePerfMarker;
    if (this.perfMarker) {
      bidLandscapePerfMarker = this.perfMarker.createChild('Campaign_Bid_Landscape');
      bidLandscapePerfMarker.willInit();
    }

    const targetEntity = getTargetEntity(event, this.grid.gridView);
    openCampaignBidLandscape({
      event,
      scope: this.scope,
      campaign: targetEntity,
      grid: this.grid,
      container: this.$el,
      isForVNext: this.isForVNext,
      bulkChange: bulkEditChange,
      perfMarker: bidLandscapePerfMarker,
    });
  }

  onLabelsRowClicked(event) {
    const targetEntity = getTargetEntity(event, this.grid.gridView);
    this.grid.gridView.trigger('willShowLabelsPopup');

    showLabelsPopup({
      labels: targetEntity.Labels,
      entityType: 'Campaign',
      entityName: targetEntity.Name,
      container: this.isForVNext ? $('.grid-and-disclaim-container') : this.$el,
      event,
      router: legacyRouter,
      i18n,
      grid: this.grid,
      filterService: this.filterService,
      isMCCLabelEnabled: IsAccountLabelsEnabled,
    });
  }

  showEditorialRejectionReason(event) {
    const key = this.grid.gridView.keyOfElement(event.target);
    const selectedItem = this.grid.gridView.itemWithKey(key);
    const editorialStatus = $(event.target).parent('.delivery-info').data('status');
    const attributeId = $(event.target).data('entityid');
    const valueLevel = $(event.target).parent('.delivery-info').data('valuelevel');
    const activity = this.instrumentation && this.instrumentation.editorial && this.instrumentation.editorial.create().toggleCountryList.create();

    import(/* webpackMode: 'eager' */'@bingads-webui-campaign/delivery-status-popup-factory').then(({ showRejectionReasons, registerCountryListEvent }) => {
      showRejectionReasons({
        event,
        i18n,
        deliveryStatusDetails: [editorialStatus],
        getCustomTemplate: _.partial(getEditorialReasonsTemplate, {
          event,
          ajaxOptions: {
            host: appConfig.get('odata.url'),
            path: appConfig.get('odata.multipart_path'),
            oDataToken: appConfig.get('odata.token'),
            params: {
              campaign_id: selectedItem.Id,
              account_id: appConfig.get('CurrentAccount').Id,
              customer_id: appConfig.get('CurrentCustomer').Id,
            },
            sessionId: appConfig.get('Omniture').SessionId,
          },
          instrumentation: this.instrumentation,
          i18n,
          attributeId,
          deliveryStatus: editorialStatus,
          valueLevel,
          permissions,
          commonI18n,
        }),
        useCustomTemplate: () => true,
        popoverId: this.popoverId,
        isForVNext: this.isForVNext,
        view: this.grid.gridView,
        afterRender: popup => registerCountryListEvent(popup.$el, activity, { entity: 'campaign customizer attribute', id: selectedItem.Id }),
      });
    });
  }
  RequestDisclaimerExceptionCallBack(adsGrid) {
    if (!this.appealAggregator) {
      const AppealAggregatorClass = AppealAggregator.default;
      this.appealAggregator = new AppealAggregatorClass({
        grid: adsGrid.grid,
        controller: 'Extension',
        submit: 'SubmitAppeal',
        menuToFollow: 'button-extension-create',
        permissions,
        instrumentation: adsGrid.instrumentation,
        requestExceptionFromPopup: true,
      });
    }
    this.appealAggregator.openBulkEditor(
      i18n.getString('InlineExtensionAppeal_RejectionTitle'),
      null,
      null,
      false,
      null,
      _.extend(this.scope.values, { type: 'disclaimer' })
    );
    return this.appealAggregator.bulkEditor;
  }

  RequestDisclaimerExceptionCallBackFromPopup(adsGrid, id) {
    if (adsGrid.isForVNext) {
      adsGrid.trigger('closeDeliveryStatusPopup');
    } else {
      $(adsGrid.rejectionPopupContainerSelector).hide();
    }

    adsGrid.grid.gridView.deselectAll();
    adsGrid.grid.gridView.selectRow(id);
    const appealView = adsGrid.RequestDisclaimerExceptionCallBack(adsGrid);

    adsGrid.grid.gridView.overrideWith(appealView.render());
    appealView.on('hide', () => {
      adsGrid.grid.gridView.overrideWith(null);
      appealView.remove();
    });
  }

  showRejectionReason(event) {
    const actionLinks = [];
    const entity = getTargetEntity(event, this.grid.gridView);
    if (this.isForVNext) {
      if (entity &&
        entity.DeliveryStatusDetails &&
        entity.DeliveryStatusDetails.includes('NoEligibleAdGroups')) {
        const url = this.router.getRoutePathById('adgroup-create');
        const uri = new URI(url);
        appendScopeParameter(uri, this.scope);
        uri.addQuery('campaignId', entity.Id);
        uri.addQuery('isOpenCreatePanel', true);
        actionLinks.NoEligibleAdGroups = uri.toString();
      }

      if (entity && entity.DeliveryStatusDetails &&
        entity.DeliveryStatusDetails.includes('ShoppingCampaignNoOffersPresent')) {
        // get merchant center url under account level
        const url = this.router.getRoutePathById('merchant-center');
        const uri = new URI(url);
        appendScopeParameter(uri, this.scope);
        actionLinks.ShoppingCampaignNoOffersPresent = uri.toString();
      }
    }

    import(/* webpackMode: 'eager' */'@bingads-webui-campaign/delivery-status-popup-factory').then(({ DeliveryStatusPopupFactory, registerCountryListEvent }) => {
      const view = new DeliveryStatusPopupFactory({ grid: this.grid, i18n });
      view.showRejectionPopup({
        event,
        actionLinks,
        containerSelector: this.rejectionPopupContainerSelector,
        IsExperimentsOpenBetaEnabled,
        isSmartShoppingCampaignEnabled: IsSmartShoppingCampaignEnabled,
        percentSymbol: this.serverContext.DecimalFormatter.percentSymbol,
        view: this,
        popoverId: this.popoverId,
        useCustomTemplate: deliveryStatus =>
          _.contains(customTemplateDeliveryStatus, deliveryStatus) || (permissions && permissions.dynamic.AdExtensionInlineAppeal && _.contains(disclaimerEditorialStatus, deliveryStatus)),
        getCustomTemplate: (deliveryStatus, index) => {
          if (_.contains(linkedInPermissionRequired, deliveryStatus)) {
            return getRequestPermission({
              i18n,
              deliveryStatus,
            });
          }
          if (_.contains(disclaimerEditorialStatus, deliveryStatus)) {
            return this.disclaimerRepos.association.findAll({
              where: {
                campaignId: entity.Id,
              },
            }).then(disclaimerData => getReasonTemplates({
              deliveryStatus,
              scope: this.scope.values,
              errI18n: i18nErrors,
              locationI18n: locationTargeti18n,
              i18n,
              commonI18n,
              permissions,
              entity,
              extension: disclaimerData && disclaimerData[0],
            }));
          }
          if (budgetLimit.indexOf(deliveryStatus) > -1) {
            return this.deliveryStatusPopupFactory.getBudgetLandscapeHelpInfoTemplate(event);
          }
          return this.deliveryStatusPopupFactory.getAutobiddingLimitedHelpInfoTemplate(deliveryStatus, index, event);
        },
        afterRender: (popupView) => {
          popupView.$('#requestLinkedInPermission').on('click', () => {
            this.grid.gridView.trigger('closeDeliveryStatusPopup');
          });
          popupView.$('#requestExceptionforExtension').on('click', _.partial(this.RequestDisclaimerExceptionCallBackFromPopup, this, entity.Id));
          registerCountryListEvent(popupView.$el);
          popupView.$('.budget-landscape-action-link').on('click', () => {
            // only the mouse over event contains campaign info
            // but only popupView could catch this click event
            // so we have to pass the mouse over event
            this.showBudgetLandscape(event);
            $(this.rejectionPopupContainerSelector).hide();
          });

          popupView.$('.autobidding-suggestion .apply').on('click', (clickEvent) => {
            // deliveryStatusList should only contain one element
            const deliveryStatusList = _.intersection(clickEvent.target.classList, autobiddingLimitedStatus);
            this.applyAutobiddingSuggestion(event, deliveryStatusList[0]);
            this.grid.gridView.trigger('closeDeliveryStatusPopup');
            clickEvent.stopPropagation();
            clickEvent.preventDefault();
          });
        },
        instrumentation: this.instrumentation,
        inContextRepairRecommedationType: 'campaign',
      });
    });
  }

  processErrors(response) {
    let errorMessage;
    const unexpectedError = i18n.getString('ErrorNumber_-1');
    if (response && response.errors) {
      const errors = i18nErrors.getBulkApiErrors(response.errors);
      if (!errors || !errors[0] || !errors[0].message) {
        errorMessage = unexpectedError;
      } else {
        errorMessage = errors[0].message;
      }
    }

    notificationApi.showWarning(errorMessage || unexpectedError);
  }

  applyAutobiddingSuggestionForMaxCPCRestriction(campaign, suggestedValue) {
    const toUpdated = {
      BiddingScheme: {
        ...campaign.BiddingScheme,
        MaxCpc: {
          Amount: suggestedValue,
        },
      },
    };

    jsdataCampaign.Campaign
      .update(campaign.Id, toUpdated, { adapter: 'bulk', cacheResponse: false })
      .finally(withUiBlock(this.grid.gridView.$el))
      .then(() => {
        notificationApi.showInfo(i18n.getString('Message_RecommendedValue_Applied'));
        this.grid.gridView.refresh(true);
      })
      .catch(response => this.processErrors(response));
  }
  // budget, shared budget
  applyAutobiddingSuggestionForBudgetRestriction(campaign, suggestedValue) {
    if (campaign && campaign.Budget) {
      if (campaign.Budget.Id) {
        // shared budget
        SharedBudgetModel.updateBudget({
          Id: campaign.Budget.Id,
          Amount: suggestedValue,
        })
          .finally(withUiBlock(this.grid.gridView.$el))
          .then(() => {
            notificationApi.showInfo(i18n.getString('Message_RecommendedValue_Applied'));
            this.grid.gridView.refresh(true);
          })
          .catch(response => this.processErrors(response));
      } else if (campaign.Budget.Amount) {
        const toUpdated = {
          Budget: _.extend({}, campaign.Budget, {
            Amount: suggestedValue,
          }),
        };
        jsdataCampaign.Campaign
          .update(campaign.Id, toUpdated, { adapter: 'bulk', cacheResponse: false })
          .finally(withUiBlock(this.grid.gridView.$el))
          .then(() => {
            notificationApi.showInfo(i18n.getString('Message_RecommendedValue_Applied'));
            this.grid.gridView.refresh(true);
          })
          .catch(response => this.processErrors(response));
      }
    }
  }
  // targetCPA, targetROAS, targetImpressionShare
  applyAutobiddingSuggestionForUnAttainableTarget(campaign, suggestedValue) {
    const toUpdated = {
      BiddingScheme: { ...campaign.BiddingScheme },
    };
    // shopping campaign - mcv+roas, mc+cpa
    if (toUpdated.BiddingScheme.Type === 'MaxConversionValue') {
      toUpdated.BiddingScheme.TargetRoas = suggestedValue;
    } else if (toUpdated.BiddingScheme.Type === 'MaxConversions') {
      toUpdated.BiddingScheme.TargetCpa = suggestedValue;
    } else {
      toUpdated.BiddingScheme[toUpdated.BiddingScheme.Type] = suggestedValue;
    }
    jsdataCampaign.Campaign
      .update(campaign.Id, toUpdated, { adapter: 'bulk', cacheResponse: false })
      .finally(withUiBlock(this.grid.gridView.$el))
      .then(() => {
        notificationApi.showInfo(i18n.getString('Message_RecommendedValue_Applied'));
        this.grid.gridView.refresh(true);
      })
      .catch(response => this.processErrors(response));
  }

  applyAutobiddingSuggestion(event, deliveryStatus) {
    const campaign = getTargetEntity(event, this.grid.gridView);
    const detail = _.filter(campaign.CampaignDeliveryStatusDetails, detailStatus => detailStatus.Status === deliveryStatus);
    const suggestedValue = detail[0] && detail[0].RecommendedValue;
    const activity = this.instrumentation && this.instrumentation.autobiddingLimitedStatus.create().applyDeliveryStatus.create();
    let currentValue = null;

    switch (deliveryStatus) {
      case 'AutoBiddingLimitedMaxCPCRestriction':
        currentValue = campaign.BiddingScheme.MaxCpc && campaign.BiddingScheme.MaxCpc.Amount;
        this.applyAutobiddingSuggestionForMaxCPCRestriction(campaign, suggestedValue);
        break;
      case 'AutoBiddingLimitedBudgetRestriction':
        currentValue = campaign.Budget.Amount;
        this.applyAutobiddingSuggestionForBudgetRestriction(campaign, suggestedValue);
        break;
      case 'AutoBiddingLimitedUnAttainableTarget':
        currentValue = campaign.BiddingScheme[campaign.BiddingScheme.Type];
        this.applyAutobiddingSuggestionForUnAttainableTarget(campaign, suggestedValue);
        break;
      default:
        break;
    }
    if (activity) {
      activity.trace(JSON.stringify({
        campaignId: campaign.Id,
        deliveryStatus,
        suggestedValue,
        currentValue,
      }));
    }
  }

  hideRejectionReason(e) {
    if ($(e.relatedTarget).closest(`#${this.popoverId}`).length === 0) {
      this.grid.gridView.trigger('closeDeliveryStatusPopup');
    }
  }

  showBudgetLandscape(event) {
    event.stopImmediatePropagation();
    // this.deliveryStatusPopupFactory.showBudgetLandscapePopup(event, this.isForVNext);

    const activity = this.instrumentation && this.instrumentation.editorial && this.instrumentation.editorial.create().toggleCountryList.create();
    this.deliveryStatusPopupFactory.showBudgetLandscapePopup(event, this.isForVNext, this.serverContext, activity, this.newI18n);
  }

  showInlineOpportunityPanel(event) {
    event.stopImmediatePropagation();
    this.deliveryStatusPopupFactory.showInlineOpportunityPanel(event, this.isForVNext);
  }

  showBudgetLandscapeHelpInfo(event) {
    event.stopImmediatePropagation();
    this.deliveryStatusPopupFactory.showBudgetLandscapeHelpInfo(event, this.isForVNext);
  }

  showQualityScoreDetails(event) {
    const targetEntity = getTargetEntity(event, this.grid.gridView);

    showQualityScoreDetail(event, targetEntity.QualityScore, 'qsContainer', legacyGlobalI18n); // qsContainer is the id from qsContainerTemplate
  }

  onWunderbarChange() {
    this.grid.gridView.monitorViewportChange(1500, 15);
  }

  showLandscapeDisabledHelpInfo(event) {
    this.showRejectionReason(_.extend({}, event, { bidlandscapeDisabled: true }));
  }

  forceCampaignsGridRefresh({ gridView }) {
    const invalidateGridData = jsdataCampaign.Campaign.destroyAll();
    invalidateGridData.then(() => {
      gridView.deselectAll();
      gridView.refresh(true);
    });
  }

  showFluctuationInsightsTooltip(event) {
    renderFluctuationInsightsTooltip({
      i18n,
      event,
      view: this.grid.gridView,
    });
  }

  showFluctuationInsightsPopup(event) {
    const { currentTarget } = event;
    event.stopPropagation();
    const targetEntity = getTargetEntity(event, this.grid.gridView);

    insertPopoverContainer(mccPerfFluxPopupContainerId);

    const dateRange = this.grid.dateFilter.getCurrentDateRange();

    import(/* webpackMode: 'eager' */'@bingads-webui-campaign-react/fluctuation-popup').then(({ createElementBasedFluctuationPopupFactory }) => {
      import(/* webpackMode: 'eager' */'@bingads-webui-campaign-react/common-styles').then(({ getFluctuationPopupStyle }) => {
        const { core } = this.theme;
        const { palette } = core;
        const getFluctuationPopupStyles = () => ({
          '@global': getFluctuationPopupStyle({ palette }),
        });
        createElementBasedFluctuationPopupFactory({
          perfMarker: this.perfMarker,
          triggerButton: currentTarget,
          onFlucDismiss: ({ isLastFluc }) => {
            if (isLastFluc) {
              this.forceCampaignsGridRefresh(this.grid);
            }
          },
          deps: {
            i18n,
            context: {
              ...this.serverContext,
              scope: this.scope,
              CurrentCampaign: {
                Id: targetEntity ? targetEntity.Id : '',
              },
            },
            instrumentation: this.instrumentation,
            azure: this.azureUrlRewrite,
            appConfig,
          },
          metrics: [{
            name: currentTarget.getAttribute('data-metric-name'),
            value: currentTarget.getAttribute('data-metric-value'),
            type: currentTarget.getAttribute('data-metric-type'),
          }],
          fromScenario: 'CampaignsGrid',
          isForVNext: this.isForVNext,
          canViewAllInsights: false,
          asyncLoadFluctuationConfig: {
            dateRange: {
              startDate: dateRange.start,
              endDate: dateRange.end,
            },
            fluctuationTypeIds: [currentTarget.getAttribute('data-metric-type')],
          },
          onDismiss: () => {
            if (currentTarget) {
              currentTarget.focus();
            }
          },
          getFluctuationPopupStyles,
        }, document.getElementById(mccPerfFluxPopupContainerId));
      });
    });
  }

  showBudgetCenterHelpInfo(event) {
    const timeZone = toIANATimeZone(fromLegacyTimeZone(_.get(this.serverContext, ['CurrentAccount', 'TimeZone'])));
    const monthString = i18n.formatDate(new Date(), { skeleton: 'MMMM', timeZone });

    const entity = getTargetEntity(event, this.grid.gridView);
    const url = this.router.getRoutePathById('budget-center');
    const uri = new URI(url);
    appendScopeParameter(uri, this.scope);
    uri.addQuery('campaignId', entity.Id);
    uri.addQuery('entrypoint', 'campaignsgrid');
    const actionLink = uri.toString();

    const monthlyBudgetAmount = i18n.formatCurrency(
      _.get(entity, ['Budget', 'MonthlyAmount']),
      _.get(this.serverContext, ['CurrentAccount', 'CurrencyCode'])
    );

    renderBudgetCenterHelpTooltip({
      i18n,
      event,
      view: this.grid.gridView,
      monthString,
      monthlyBudgetAmount,
      actionLink,
    });
  }

  renderPerformanceInsightsPopup({
    event, containerDOM, closePerformanceInsightsPopup,
  }) {
    ReactDOM.render(
      (<PerformanceInsightsToolTipCard
        event={event}
        closePerformanceInsightsPopup={closePerformanceInsightsPopup}
        i18n={i18n}
        newI18n={this.newI18n}
        entity={getTargetEntity(event, this.grid.gridView)}
        serverContext={this.serverContext}
      />),
      containerDOM
    );
  }

  closePerformanceInsightsPopup() {
    if (window.popupManager) {
      window.popupManager.releaseLock(popupContentKey);
    }
    ReactDOM.unmountComponentAtNode(document.querySelector(this.rejectionPopupContainerSelector));
  }

  showPerformanceInsightsPopup(event) {
    const containerDOM = document.querySelector(this.rejectionPopupContainerSelector);
    if (window.popupManager) {
      window.popupManager.forceAcquireLock(popupContentKey);
    }

    this.renderPerformanceInsightsPopup({
      event, containerDOM, closePerformanceInsightsPopup: this.closePerformanceInsightsPopup.bind(this),
    });
  }

  hidePerformanceInsightsPopup(e) {
    if ($(e.relatedTarget).closest('.performance-insights-callout').length === 0) {
      this.closePerformanceInsightsPopup();
    }
  }

  get className() { return 'campaign-tab-grid'; }
}
